import React from 'react';
import styles from './Video.module.css';

const YouTube = (props) => {
  return (
    <div>
      <iframe
        width={props.width || '560'}
        height={props.height || '315'}
        src={'https://www.youtube.com/embed/' + props.url}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className={styles.video}
      ></iframe>
    </div>
  );
};

export default YouTube;
